import React from "react";
import Login from "./login/MaterialLogin";
import ImpersonatedLogin from "./login/ImpersonatedLogin";
import ResetPassword from './pages/forgotPassword';
import SelfRegister from './comps/selfRegister';
import Signup from './comps/signup';
import PairRegister from './comps/pairRegister';
import ClientReports from './comps/clientReports';
import CustomReports from './comps/customReports';
import PolicyViewer from './comps/policyViewer';
import MiniAssessment from './comps/miniAssessment';
import { miniDirectory } from './generalTables/mini-assessments'
import NewNavbar from "./comps/pageLayout";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import ProtectedRoute from "./comps/protectedRoute"; 

export default function App() {
  return (
    <Router>
      <Switch>
        <Route path="/coachportal/resetpassword">
          <ResetPassword/>
        </Route>
        <Route path="/coachportal/login">
          <Login />
        </Route>
        <Route path={`/coachportal/${miniDirectory}/:uuid([0-9a-fA-F-]{1,36})`}>
          <MiniAssessment />
        </Route>
        <Route path="/coachportal/register/:uuid">
          <SelfRegister  mode="register" />
        </Route>
        <Route path="/coachportal/signup/:uuid">
          <Signup />
        </Route>
        <Route path="/coachportal/pairregister/:uuid">
          <PairRegister  mode="register" />
        </Route>
        <Route path="/coachportal/reports/:uuid([0-9a-fA-F-]{36})">
          <ClientReports legacy={true}/>
        </Route>
        <Route path="/coachportal/reports/:reportCode/:uuid([0-9a-fA-F-]{36})">
          <ClientReports />
        </Route>
        <Route path="/coachportal/customreports/:reportCode/:uuid([0-9a-fA-F-]{36})">
          <CustomReports />
        </Route>
        <Route path="/coachportal/policies/:coachUUID([0-9a-fA-F-]{36})/:policyUUID([0-9a-fA-F-]{36})">
          <PolicyViewer />
        </Route>
        <Route path="/coachportal/paymentstatus">
          <SelfRegister mode="postpayment"/>
        </Route>
        <Route path="/coachportal/pairpaymentstatus">
          <PairRegister mode="postpayment"/>
        </Route>
        <Route path="/coachportal/impersonate">
          <ImpersonatedLogin />
        </Route>
        <ProtectedRoute path="/coachportal">
          <NewNavbar />
        </ProtectedRoute>
        {/* the following lines - partially for getting Dashboard title in place but anything else? */}
        <Route exact path="/coachportal">
          <Redirect exact from="/coachportal/dashboard" to="dashboard" />
        </Route>
        <Route path="*">
          <Redirect from="/coachportal/dashboard" to="dashboard" />
        </Route>
      </Switch>
    </Router>
  );
}
